import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { mapOperations } from '../redux/map';
import { incidentOperations } from '../redux/incident';
import { resourceOperations } from '../redux/resource';
import Map from '../esri/Map';
import CircularProgress from 'material-ui/CircularProgress';
import { arrayToLookup, getFilterDefs } from '../utils/helpers';
import { filters as filterDefs } from '../defaults/filter/filter.json';
import { geometryAttributes } from '../defaults/geometryAttributes.json';
import theme from '../muiTheme';

class MapContainer extends Component {
  getLoaderContent = () => {
    let loaderDiv;
    if (!this.props.map.loaded) {
      loaderDiv = (
        <div className="map-splash map-loading">
          <div className="map-loading-icon">
            <CircularProgress size={120} />
          </div>
          <p style={{ color: theme.palette.textColor }}>Loading Map</p>
        </div>
      );
    }
    return loaderDiv;
  };

  setFieldDefs = (fields, layer) => {
    const fieldsWithGeometry = [...fields, ...geometryAttributes];

    // define what they're going to look like in defaults folder (as JSON)
    if (layer === 'incidents') {
      this.props.setIncidentFields(arrayToLookup(fieldsWithGeometry, 'name'));
    }

    if (layer === 'incidentHistory') {
      this.props.setIncidentHistoryFields(
        arrayToLookup(fieldsWithGeometry, 'name')
      );
    }

    if (layer === 'resources') {
      this.props.setResourceFields(arrayToLookup(fieldsWithGeometry, 'name'));
    }
  };

  setIncidentFilterDefs = fields => {
    const filterState = getFilterDefs(filterDefs, fields);
    this.props.setInitialIncidentFilter(filterState);
  };

  render() {
    return (
      <Fragment>
        {this.getLoaderContent()}
        <div
          className={
            'map-container' +
            (this.props.map.loaded ? ' map-loaded' : ' map-loading')
          }
        >
          <Map
            appConfig={this.props.appConfig}
            user={this.props.auth.user}
            onMapLoaded={this.props.mapLoaded}
            setFieldDefs={this.setFieldDefs}
            setIncidentFilterDefs={this.setIncidentFilterDefs}
            updateExtent={this.props.setExtent}
            history={this.props.history}
            isDetailMap={this.props.isDetailMap}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  auth: state.auth,
  appConfig: state.config
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...mapOperations,
      ...incidentOperations,
      ...resourceOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MapContainer)
);



// WEBPACK FOOTER //
// ./src/components/MapContainer.js